export default "__VITE_ASSET__BnQheDVQ__"